import {
  type IconType,
  SiFacebook,
  SiGithub,
  SiInstagram,
  SiX,
  SiYoutube,
} from '@icons-pack/react-simple-icons';

import {
  SITE_FACEBOOK_URL,
  SITE_GITHUB_URL,
  SITE_INSTAGRAM_URL,
  SITE_LINKEDIN_URL,
  SITE_X_URL,
  SITE_YOUTUBE_URL,
} from './website';

type SocialLinks = Array<{
  href: string;
  title: string;
  icon: IconType;
}>;

export const SOCIAL_LINKS: SocialLinks = [
  {
    href: SITE_GITHUB_URL,
    title: 'GitHub',
    icon: SiGithub,
  },
  {
    href: SITE_FACEBOOK_URL,
    title: 'Facebook',
    icon: SiFacebook,
  },
  {
    href: SITE_INSTAGRAM_URL,
    title: 'Instagram',
    icon: SiInstagram,
  },
  {
    href: SITE_X_URL,
    title: 'X',
    icon: SiX,
  },
  {
    href: SITE_YOUTUBE_URL,
    title: 'YouTube',
    icon: SiYoutube,
  },
];

export const FOOTER_LINKS = [
  {
    id: 1,
    links: [
      { href: '/', key: 'home' },
      { href: '/posts', key: 'blog' },
      { href: '/about', key: 'about' },
      { href: '/dashboard', key: 'dashboard' },
    ],
  },
  {
    id: 2,
    links: [
      { href: '/guestbook', key: 'guestbook' },
      { href: '/experience', key: 'experience' },
      { href: '/projects', key: 'projects' },
      { href: 'https://links.trev.fyi', key: 'links' },
    ],
  },
  {
    id: 3,
    links: [
      { href: SITE_LINKEDIN_URL, key: 'linkedin' },
      { href: SITE_FACEBOOK_URL, key: 'facebook' },
      { href: SITE_INSTAGRAM_URL, key: 'instagram' },
      { href: SITE_GITHUB_URL, key: 'github' },
    ],
  },
] as const;
